import { getFromSdk } from './utils';

export const PERMISSION_STATUS = {
    GRANTED: 'granted',
    DENIED: 'denied',
    DEFAULT: 'default',
};

// REGISTRATION
export const registerUser = async() => {
    const sdk = await getFromSdk();

    return sdk.register(); // user will be asked to give notifications permission
};

export const canRegister = () => {
    return getFromSdk('canRegister');
};

export const getChannelId = () => {
    return getFromSdk('channel.id');
};

export const getChannel = () => {
    return getFromSdk('channel');
};

export const isSupported = () => {
    return getFromSdk('isSupported');
};


export const getPermission = () => {
    return getFromSdk('permission');
};

export const getSdk = () => {
    return getFromSdk();
};

// OPT IN/OUT
export const isOptedIn = () => getFromSdk('channel.optedIn');

export const optOut = async () => {
    const notificationsOptOut = await getFromSdk('channel.optOut');

    return !notificationsOptOut ? null : await notificationsOptOut();
};

